var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinux = function SvgLinux(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.774 15.001a.72.72 0 0 0-.579.288l-1.775 2.367a2.092 2.092 0 0 0 .194 2.735v0c.736.736 1.902.819 2.735.194l2.365-1.773a.726.726 0 0 0 .29-.58v-.602c0-.697-.277-1.366-.77-1.859v0a2.629 2.629 0 0 0-1.859-.77zM6.227 15.001a.72.72 0 0 1 .578.288l1.776 2.367a2.092 2.092 0 0 1-.195 2.735v0a2.092 2.092 0 0 1-2.734.194l-2.365-1.773a.726.726 0 0 1-.29-.58v-.602c0-.697.277-1.366.77-1.859v0a2.629 2.629 0 0 1 1.858-.77zM10.052 11.431l1.112.556a1.869 1.869 0 0 0 1.671 0l1.112-.556a1 1 0 0 0 0-1.79l-.694-.346a2.803 2.803 0 0 0-2.507 0l-.694.347a1 1 0 0 0 0 1.79",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.5 7.498v1.92M13.5 7.498v1.92M15.072 18.374a10.04 10.04 0 0 0-.92-7.084M9.849 11.29a10.04 10.04 0 0 0-.92 7.084"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.126 15.05c-.02-.44.108-.876.363-1.237l.146-.205a10.005 10.005 0 0 0 1.863-5.814v-.296a4.502 4.502 0 0 1 9.004 0v.296c0 2.085.652 4.118 1.863 5.814l.146.205c.255.36.383.796.363 1.238M15.313 19.996a3.152 3.152 0 0 1-1.582-.477l-.051-.032a3.156 3.156 0 0 0-3.36 0l-.05.032a3.152 3.152 0 0 1-1.582.477"
  })));
};
export { SvgLinux as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNDZkMjEwOTI2OTJjMDE2OGE0ZDcyN2ZhNTkzMzA4YzIuc3ZnIjs=";